module.exports = __webpack_public_path__ + "img/tz.4bb3ff4e.png";